<template>
  <nav
    :class="{'bg-white': showMenu, 'navbar-transparent': !showMenu}"
    class="navbar navbar-expand-lg navbar-absolute">
    <div class="container-fluid">
      <div class="navbar-wrapper">
        <div
          :class="{toggled: $sidebar.showSidebar}"
          class="navbar-toggle d-inline">
          <button
            type="button"
            class="navbar-toggler"
            aria-label="Navbar toggle button"
            @click="toggleSidebar">
            <span class="navbar-toggler-bar bar1"/>
            <span class="navbar-toggler-bar bar2"/>
            <span class="navbar-toggler-bar bar3"/>
          </button>
        </div>
        <p
          class="navbar-brand">Crane Training Portal
        </p>
      </div>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navigation"
        aria-controls="navigation-index"
        aria-label="Toggle navigation"
        @click="toggleMenu">
        <span class="navbar-toggler-bar navbar-kebab"/>
        <span class="navbar-toggler-bar navbar-kebab"/>
        <span class="navbar-toggler-bar navbar-kebab"/>
      </button>

      <collapse-transition>
        <div
          v-show="showMenu"
          class="collapse navbar-collapse show">
          <ul class="navbar-nav ml-auto">
            <base-dropdown
              tag="li"
              title-tag="a"
              class="nav-item"
              menu-classes="dropdown-navbar">
              <a
                slot="title"
                href="#"
                class="dropdown-toggle nav-link"
                data-toggle="dropdown"
                aria-expanded="true">
                <div class="photo">
                  <img :src="user?user.avatar:''">
                </div>
                <b class="caret d-none d-lg-block d-xl-block"/>
                <p
                  class="d-lg-none"
                  @click="logout">
                  Log out
                </p>
              </a>
              <li class="nav-link">
                <a
                  href="#"
                  class="nav-item dropdown-item"
                  @click="logout">Log out</a>
              </li>
            </base-dropdown>
          </ul>
        </div>
      </collapse-transition>
    </div>
  </nav>
</template>
<script>
import { CollapseTransition } from 'vue2-transitions'
import Modal from '@/components/Modal'
import { mapState } from 'vuex'
import axios from "axios";

export default {
  components: {
    CollapseTransition,
    Modal
  },
  // computed: {
  //   routeName() {
  //     const { name } = this.$route;
  //     return this.capitalizeFirstLetter(name);
  //   },
  // },
  data () {
    return {
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      city: '',
      searchQuery: ''
    }
  },
  computed: {
    ...mapState(['user'])
  },
  mounted () {
    this.city = this.$store.state.city
  },
  methods: {
    logout () {
      var self = this
      this.$store.dispatch('logout')
        .then(() => {
          this.$cookies.set('token', '', '2m', '/', process.env.VUE_APP_API_COOKIE_DOMAIN || '.lfstraining.com')
          delete axios.defaults.headers.common['Authorization']
          self.$router.push('/')
        })
        .catch(err => {
          console.log(err)
          self.snackbar = true
        }
        )
    },
    toggleNotificationDropDown () {
      this.activeNotifications = !this.activeNotifications
    },
    closeDropDown () {
      this.activeNotifications = false
    },
    toggleSidebar () {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
    },
    hideSidebar () {
      this.$sidebar.displaySidebar(false)
    },
    toggleMenu () {
      this.showMenu = !this.showMenu
    }
  }
}
</script>
<style>
</style>
